import { useQueryClient } from '@tanstack/react-query';
import { nanoid } from 'nanoid/non-secure';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '@/shared/lib/redux';

import { ROUTES } from '@/shared/constants';

import { resetClassifiers } from '@/entities/classifiers';
import { resetUser } from '@/entities/user';
import {
  resetVideoReading,
  resetVideoReadingSettings
} from '@/entities/video-reading';

import { LOGOUT_EVENT } from '../constants/events';
import { clearReturnTo } from './returnTo';

/**
 * Функция для отправки события разлогина в другие вкладки
 */
export const triggerLogoutEvent = () => {
  localStorage.setItem(LOGOUT_EVENT, nanoid());
  localStorage.removeItem(LOGOUT_EVENT);
};

/**
 * Хук для выполнения действий при разлогине
 */
const useLogoutActions = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  /**
   * Выполняет разлогин
   */
  const makeLogout = () => {
    dispatch(resetUser());
    dispatch(resetVideoReading());
    dispatch(resetVideoReadingSettings());
    dispatch(resetClassifiers());
    clearReturnTo();
    queryClient.clear();
    navigate(ROUTES.root);
  };

  return makeLogout;
};

/**
 * Хук разлогина
 */
export const useLogout = () => {
  const makeLogout = useLogoutActions();

  return (isShouldTriggerEvent?: boolean) => {
    makeLogout();

    if (isShouldTriggerEvent) triggerLogoutEvent();
  };
};
